import * as qs from 'query-string';

export class UrlHandler<T> {
    private _settings = { skipNull: false, skipEmptyString: false, arrayFormat: 'bracket' };

    public updateWithUrlParams(search: T | null): T {
        const parsed        = qs.parse(typeof window !== 'undefined' ? window.location.search : '', this._settings);
        const defaultSearch = (typeof search === 'object' && search !== null) ? search : {};
        const urlOverride   = (typeof parsed === 'object' && parsed !== null) ? parsed : {};
        const isEmpty       = Object.keys(defaultSearch).length === 0 && Object.keys(urlOverride).length === 0;

        return isEmpty ? null : { ...defaultSearch, ...urlOverride } as T;
    }

    public toQueryString(search: T): string {
        return qs.stringify(search as any, this._settings);
    }

    public pushSearchUrl(search: T) {
        const query = this.toQueryString(search) || '';
        
        window.history.pushState({}, '', `${window.location.pathname}?${query}${window.location.hash}`);
    }
}
